<template>
	<div class="bg">
		<div class="bg2">
			<div class="top">
				<img @click="open('https://www.zhihuishu.com/virtual_portals_h5/virtualExperiment.html#/indexPage?courseId=2000099114')" src="../assets/智慧树.png" class="topleft" alt="" />
				<KinesisContainer>
					<kinesis-element :strength="10">
						<img src="../assets/title.png" class="titleText" style="" alt="" />
					</kinesis-element>
				</KinesisContainer>
				<KinesisContainer>
					<kinesis-element :strength="10">
						<div @click="open('https://www.zhihuishu.com/virtual_portals_h5/virtualExperiment.html#/indexPage?courseId=2000099114')" class="button">
							<img src="../assets/mine.png" class="topright1" alt="" />
							<div class="topright2">进入课程</div>
						</div>
					</kinesis-element>
				</KinesisContainer>
			</div>
			
			<div class="bottom">
				<div>
					<div style="display: flex;justify-content: center;">
						<div class="bottom1">
							<KinesisContainer>
								<kinesis-element :strength="10">
									<img @click="open('http://47.109.29.194:8097/1/index.html')" src="../assets/6.png" class="bottom11" alt="" />
								</kinesis-element>
							</KinesisContainer>
							<KinesisContainer>
								<kinesis-element :strength="10">
									<div class="bottom12">
										<img @click="open('http://47.109.29.194:8095/1/index.html')" src="../assets/5.png" class="bottom13" alt="" />
									</div>
								</kinesis-element>
							</KinesisContainer>
							<KinesisContainer>
								<kinesis-element :strength="10">
									<img @click="open('https://lsxy.henu.edu.cn/ai_gjj.jsp?urltype=tree.TreeTempUrl&wbtreeid=1655')" src="../assets/4.png" class="bottom11" alt="" />
								</kinesis-element>
							</KinesisContainer>
						</div>
					</div>
					<div class="bottom2">
						<KinesisContainer>
							<kinesis-element :strength="10">
								<div class="bottom21">
									<img @click="open('http://47.109.29.194:8091/1/index.html')" src="../assets/7.png" class="bottom22" alt="" />
								</div>
							</kinesis-element>
						</KinesisContainer>
						<KinesisContainer>
							<kinesis-element :strength="10">
								<img @click="open('http://47.109.29.194:8093/1/index.html')" src="../assets/2.png" class="bottom23" alt="" />
							</kinesis-element>
						</KinesisContainer>
						<KinesisContainer>
							<kinesis-element :strength="10">
								<img @click="open('http://47.109.29.194:81')" src="../assets/1.png" class="bottom23" alt="" />
							</kinesis-element>
						</KinesisContainer>
						<KinesisContainer>
							<kinesis-element :strength="10">
								<div class="bottom21">
									<img @click="open('http://47.109.29.194:8090/1/gwx.html')" src="../assets/3.png" class="bottom22" alt="" />
								</div>
							</kinesis-element>
						</KinesisContainer>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		KinesisContainer,
		KinesisElement
	} from 'vue-kinesis'
	export default {
		components: {
			KinesisContainer,
			KinesisElement
		},
		methods: {
			open(url){
				window.open(url)
			}
		}
	}
</script>

<style>
	.bottom2 {
		width: 1676px;
		display: flex;
		justify-content: space-between;
		margin-bottom: -230px;
		align-items: end;
	}

	.bottom21 {
		padding-bottom: 130px;
	}

	.bottom22 {
		width: 365px;
		height: 383px;
	}

	.bottom23 {
		width: 365px;
		height: 362px;
	}

	.bottom13 {
		width: 265px;
		height: 282.47px;
	}

	.bottom12 {
		padding-bottom: 30px;
	}

	.bottom11 {
		width: 265px;
		height: 287.47px;
	}

	.bottom1 {
		width: 904px;
		display: flex;
		justify-content: space-between;
		margin-bottom: -230px;
		align-items: end;
	}

	.bottom {
		display: flex;
		justify-content: center;
		width: 100%;
		margin-top: 80px;
	}

	.titleText {
		width: 1266px;
		height: 196px;
	}

	.title {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}

	.topright2 {
		color: white;
		font-size: 22px;
		margin-left: 5px;
	}

	.topright1 {
		width: 22px;
		height: 22px;
	}

	.topleft {
		width: 210px;
		height: 25.5px;
	}

	.top {
		margin-top: 40px;
		padding: 40px;
		display: flex;
		align-items: start;
		justify-content: space-between;
	}

	.bg {
		background-image: url('../assets/bg.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: cover;
		min-height: 1100px;
		width: 1920px;
		overflow-x: hidden;
	}

	.bg2 {
		background-image: url('../assets/bg2.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-position: cover;
		min-height: 1100px;
		width: 1920px;
		overflow-x: hidden;
	}

	.button {
		background-image: url('../assets/button.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: 163px;
		height: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>